<template>
  <div id="tables-screen" translate="no">
    <Loading
      :active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :height="40"
      loader="spinner"
      color="#003340"
    ></Loading>
    <BackToServices
      :table="tableId"
      :storeName="storeName"
      :isApplication="isApplication"
      :hasBoxShadow="true"
      :amountOfDepartments="2"
      :goBackToOpenTables="false"
      :pdaMobileScreen="false"
      :restaurantType="'OPENINGS'"
      id="back-to-services"
    ></BackToServices>
    <div id="banner">
      <img v-if="store" id="banner-image" :src="`${store.bannerLink}`" alt />

      <div id="store-info">
        <Store id="store" :store="store" :shouldShowMenu="false"></Store>
      </div>

      <div id="upper-bar">
        <div id="logo-container" v-if="!isApplication">
          <a id="link-to-landing" href>
            <img id="logo" src="../../assets/Full_logo-Black.svg" alt />
          </a>
        </div>
        <div id="profile-and-cart">
          <LanguageSelect
            v-if="isAbleToChangeLanguage"
            id="language-select"
            :class="{ 'language-position-in-login': isLoggedIn }"
          ></LanguageSelect>

          <ProfileDropdown
            v-if="isLoggedIn"
            id="profile-dropdown"
            :isApplication="isApplication"
            :class="{ 'profile-dropdown-with-lang-select': isAbleToChangeLanguage,
                    'profile-dropdown-without-lang-select': !isAbleToChangeLanguage }"
          ></ProfileDropdown>
          <EnterPrompt
            v-else-if="shouldShowEnterPrompt && !isLoggedIn && !isApplication"
            @enter-clicked="initiateEntrance"
            id="enter-prompt"
            :class="{ 'enter-prompt-with-lang-select': isAbleToChangeLanguage,
                    'enter-prompt-without-lang-select': !isAbleToChangeLanguage }"
          ></EnterPrompt>
        </div>
      </div>
    </div>
    <div class="tables-container" v-if="!isLoading">
      <div
        v-if="adminAccounts!=null && adminAccounts.length>0"
        class="label-and-name"
        style="margin-top: 4px"
      >
        <div class="label" style="margin-right:10px">
          <h6 class="department-title no-bottom-margin">
            Συνδεδεμένος:
            <span id="name-of-connected-user">
              {{adminAccounts[0].name}}
              <font-awesome-icon icon="user" style="margin-left: 2px;" />
            </span>
          </h6>
        </div>
      </div>

      <div id="select-department-container">
        <div id="departments-container" v-if="restaurantsWithTableOpenings.length>1">
          <button
            v-for="restaurant in restaurantsWithTableOpenings"
            :key="restaurant.id"
            :value="restaurant.id"
            @click="selectDepartment(restaurant.id)"
            class="department-selection-button"
            :class="{ 'selected-department': selectedDepartmentId == restaurant.id }"
          >{{restaurant.names.translation[language].name}}</button>
        </div>

        <div
          id="sections-container"
          v-if="sections.length>0 && restaurantsWithTableOpenings.length>1"
        >
          <button
            @click="setSelectedSection('ALL')"
            class="section-selection-button"
            :class="{ 'selected-section': selectedSection=='ALL' }"
          >Όλα</button>
          <button
            v-for="(section, index) in sections"
            :key="index"
            :value="section"
            @click="setSelectedSection(section)"
            class="section-selection-button"
            :class="{ 'selected-section': selectedSection==section }"
          >{{section}}</button>
          <button
            v-if="sectionsOfUser.length == 0"
            @click="setSelectedSection(null)"
            class="section-selection-button"
            :class="{ 'selected-section': selectedSection==null }"
          >Υπόλοιπα</button>
        </div>

        <div class="label-and-name" :class="{ 'mt4': restaurantsWithTableOpenings.length==1 }">
          <div
            class="label"
            style="margin-right:10px"
            v-if="!tableTypesToFetchOpenings.includes('HOTEL_ROOM')"
          >
            <h6
              class="department-title no-bottom-margin"
            >{{labels.tableOpenings.typeOfTable[language]}}:</h6>
            <select
              @change="onTypeOfTableOpeningChange"
              class="no-bottom-margin"
              v-model="typeOfTableOpenings"
            >
              <option value="TABLES">{{labels.table.tables[this.language]}}</option>
              <option value="SELF_SERVICE">{{labels.table.selfService[this.language]}}</option>
            </select>
          </div>
          <div class="label">
            <h6 class="department-title no-bottom-margin">{{labels.tableOpenings.search[language]}}</h6>
            <input class="search-tables-input" v-model="tableToSearch" placeholder="πχ Τ-02" />
          </div>
        </div>

        <div
          id="sections-container"
          v-if="sections.length>0 && restaurantsWithTableOpenings.length<=1"
        >
          <button
            @click="setSelectedSection('ALL')"
            class="section-selection-button"
            :class="{ 'selected-section': selectedSection=='ALL' }"
          >Όλα</button>
          <button
            v-for="(section, index) in sections"
            :key="index"
            :value="section"
            @click="setSelectedSection(section)"
            class="section-selection-button"
            :class="{ 'selected-section': selectedSection==section }"
          >{{section}}</button>
          <button
            v-if="sectionsOfUser.length == 0"
            @click="setSelectedSection(null)"
            class="section-selection-button"
            :class="{ 'selected-section': selectedSection==null }"
          >Υπόλοιπα</button>
        </div>

        <div class="label-and-name" style="margin-top: 7px !important; flex-wrap: wrap;">
          <h6
            class="open-tables-details-title"
            style="margin-bottom: 0px"
            v-if="store.id!=234 || (store.id==234 && userCanSeeHistory)"
          >{{!tableTypesToFetchOpenings.includes('HOTEL_ROOM') && isAtLeastOneRestaurantPublishesReceipts && userCanPanicButton && typeOfTableOpenings=='TABLES' ? '' : labels.tableOpenings.totalOfOpen[language]}} {{tableOpeningsToShowTotal.toFixed(2)}}€</h6>

          <h6
            @click="toggleShowOnlyOpenTables()"
            class="open-tables-details-title"
            style="margin-bottom: 0px; margin-left:6px"
          >{{store.id!=234 || (store.id==234 && userCanSeeHistory) ? ' | Aνοιχτά': 'Aνοιχτά'}}</h6>

          <label
            class="switch"
            v-if="!tableTypesToFetchOpenings.includes('HOTEL_ROOM') && typeOfTableOpenings=='TABLES'"
          >
            <input type="checkbox" v-model="showOnlyOpenTables" />
            <span class="slider round"></span>
          </label>

          <h6
            v-if="!tableTypesToFetchOpenings.includes('HOTEL_ROOM') && (userCanPanicButton || userCanPrintOpenTempsReport) && typeOfTableOpenings=='TABLES'"
            class="open-tables-details-title"
            style="margin-bottom: 0px; margin-left:6px"
          >{{' | '}}</h6>

          <button
            v-if="!tableTypesToFetchOpenings.includes('HOTEL_ROOM') && isAtLeastOneRestaurantPublishesReceipts && userCanPanicButton && typeOfTableOpenings=='TABLES'"
            id="generate-non-publised-temp"
            @click="generateNonPublishedTempReceipts(false)"
          >
            <font-awesome-icon v-if="!generatingTempReceipts" :icon="['fas','bell-slash']" />
            <clip-loader
              v-if="generatingTempReceipts"
              :loading="generatingTempReceipts"
              size="12px"
              color="#ffffff"
            />
          </button>

          <button
            v-if="!tableTypesToFetchOpenings.includes('HOTEL_ROOM') && isAtLeastOneRestaurantPublishesReceipts && userCanPanicButton && typeOfTableOpenings=='TABLES'"
            id="generate-non-publised-temp"
            class="print-temps-panic-button"
            @click="generateNonPublishedTempReceipts(true)"
          >
            <font-awesome-icon v-if="!generatingTempReceipts" icon="bullhorn" />
            <clip-loader
              v-if="generatingTempReceipts"
              :loading="generatingTempReceipts"
              size="12px"
              color="#ffffff"
            />
          </button>

          <button
            v-if="!tableTypesToFetchOpenings.includes('HOTEL_ROOM') && isAtLeastOneRestaurantPublishesReceipts && userCanPrintOpenTempsReport && typeOfTableOpenings=='TABLES'"
            id="print-open-temps-report"
            @click="printTempReceiptsReport()"
          >
            <font-awesome-icon
              v-if="!printingOpenTempsReport"
              style="margin-left:1px;"
              icon="receipt"
            />
            <clip-loader
              v-if="printingOpenTempsReport"
              :loading="printingOpenTempsReport"
              size="12px"
              color="#ffffff"
            />
          </button>
        </div>
        <div v-if="error" class="label-and-name" style="margin-top: 0px !important">
          <p class="error-message">{{errorMessage}}</p>
        </div>
        <div v-if="successfullAction" class="label-and-name" style="margin-top: 0px !important">
          <p class="success-message">{{successMessage}}</p>
        </div>
      </div>

      <div id="table-items" v-if="tableOpeningsToShow.length > 0">
        <div
          class="table-opening"
          v-for="tableOpening in tableOpeningsToShow"
          :class="{ 'just-closed-table': !tableOpening.currentlyOpen && tableOpening.id!=null,'open-table': tableOpening.currentlyOpen, 'blue-table': tableOpening.currentlyOpen && tableOpening.minimumConsumption>0 && tableOpening.totalPrice>=tableOpening.minimumConsumption, 'red-table': tableOpening.currentlyOpen && store.assignedTablesOnly && tableOpening.openingUserId != null && waiterOfcurrentUser.ableToViewAllOpenTables && !waiterOfcurrentUser.ableToEditOtherOpenTables && waiterOfcurrentUser.userId!=tableOpening.openingUserId }"
          :key="tableOpening.id"
          @click="openTableOrders(tableOpening)"
        >
          <div class="table-opening-header-container">
            <div class="table-and-section-container">
              <h5
                class="table-opening-table-header"
                :class="{ 'no-bottom-margin': sections.length>0, 'dark-table-header' : !tableOpening.currentlyOpen }"
              >
                <font-awesome-icon
                  v-if="tableOpening.table.type == 'BEACH_CHAIR' || tableOpening.table.type == 'UMBRELLA_AT_HOTEL'"
                  icon="umbrella-beach"
                  style="margin-left: 2px;"
                />
                <font-awesome-icon
                  v-else-if="tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL'"
                  icon="chair"
                  style="margin-left: 2px;"
                />
                <font-awesome-icon
                  v-else-if="tableOpening.table.type=='HOTEL_ROOM'"
                  icon="bed"
                  style="margin-left: 2px;"
                />
                {{tableOpening.table.tableNumber}} {{tableOpening.alias}}
              </h5>
              <h5
                v-if="typeOfTableOpenings=='SELF_SERVICE'"
                class="self-service-origin-table-header"
              >{{tableOpening.originTableTitle != null && tableOpening.originTableTitle.trim().length>0 ? tableOpening.originTableTitle : '-'}}</h5>
              <h5
                v-if="sections.length>0 && typeOfTableOpenings!='SELF_SERVICE'"
                class="table-opening-section-header"
                :class="{ 'darker-section-header': tableOpening.currentlyOpen}"
              >{{tableOpening.table.familySection!=null ? tableOpening.table.familySection : 'Υπόλοιπα'}}</h5>
            </div>

            <div
              v-if="tableOpening.amountOfOpenTempReceipts>0 || (tableOpening.amountOfCardReceipts +tableOpening.amountOfCashReceipts + tableOpening.amountOfOnCreditReceipts + tableOpening.amountOfSelfDeliveryReceipts)>0"
              class="receipt-info-container"
            >
              <h5 v-if="tableOpening.amountOfOpenTempReceipts>0" class="temp-receipt-info-header">
                {{tableOpening.amountOfOpenTempReceipts.toFixed(2)}}
                <font-awesome-icon style="margin-left:2px" icon="list-alt" />
              </h5>
              <h5
                v-if="(tableOpening.amountOfCardReceipts +tableOpening.amountOfCashReceipts + tableOpening.amountOfOnCreditReceipts + tableOpening.amountOfSelfDeliveryReceipts)>0"
                class="final-receipt-info-header"
              >
                {{(tableOpening.amountOfCardReceipts +tableOpening.amountOfCashReceipts + tableOpening.amountOfOnCreditReceipts + tableOpening.amountOfSelfDeliveryReceipts).toFixed(2)}}
                <font-awesome-icon style="margin-left:2px" icon="cash-register" />
              </h5>
            </div>
          </div>

          <h5
            v-if="store.assignedTablesOnly"
            class="table-opening-service-header"
          >Service: {{findServiceName(tableOpening.openingUserId)}}</h5>
          <h5
            v-if="tableOpening.note!=null && tableOpening.note.trim().length!=0 "
            class="table-opening-note-header"
          >
            <font-awesome-icon icon="sticky-note" style="margin-left: 1px;" />
            {{tableOpening.note.slice(0,16)}}{{tableOpening.note.slice(0,16).length < tableOpening.note.length ? '..' : ''}}
          </h5>
          <h5
            v-else
            class="table-opening-no-note-header"
          >{{tableOpening.id==null ? '-': 'Xωρίς σημείωση'}}</h5>
          <hr style="margin-top: 4px" />
          <h5
            v-if="tableOpening.id!=null "
            class="table-opening-table-total"
          >{{labels.tableOpenings.totalCost[language]}} {{(tableOpening.totalPrice + tableOpening.amountCanceled + tableOpening.amountTreated).toFixed(2)}}€</h5>
          <h5 class="table-opening-table-total" v-else>-</h5>
          <h5
            v-if="tableOpening.currentlyOpen"
            class="table-opening-remaining-total mb0"
          >{{labels.tableOpenings.toBePaid[language]}} {{amountRemainingToBePaid(tableOpening)}}€</h5>
          <h5
            class="table-opening-remaining-total mb0"
            v-else
          >{{!tableOpening.currentlyOpen && tableOpening.id!=null ? labels.tableOpenings.paidOff[language]: 'Κλειστό τραπέζι'}}</h5>
          <div
            v-if="tableOpening.id!=null && tableOpening.currentlyOpen && tableOpening.minimumConsumption>0 && tableOpening.totalPrice<tableOpening.minimumConsumption"
          >
            <h5 class="table-opening-minimum-remaining mb2">
              {{labels.tableOpenings.forMinimum[language]}} {{(tableOpening.minimumConsumption - tableOpening.totalPrice).toFixed(2)}}€
              <div class="minimum-progress-wrapper">
                <div
                  class="minimum-progress"
                  :style="{width: getMinimumPercentage(tableOpening) + '%'}"
                ></div>
              </div>
            </h5>
          </div>
          <div>
            <h6 class="table-opening-table-date" v-if="tableOpening.openingDate!=null">
              {{tableOpening.openingDate.slice(0, -3)}}
              <font-awesome-icon
                v-if="tableOpening.openingUserId==null && tableOpening.id!=null && tableOpening.currentlyOpen && ((typeOfTableOpenings=='TABLES' && !tableTypesToFetchOpenings.includes('HOTEL_ROOM')) || typeOfTableOpenings=='SELF_SERVICE')"
                style="margin-left:4px; color:#8b36e6"
                icon="user"
              />
              <font-awesome-icon
                v-if="tableOpening.id!=null && tableOpening.currentlyOpen && tableOpening.allOrdersExecuted"
                style="margin-left:4px; color:#198b4a; font-size:14px"
                icon="check"
              />
            </h6>
            <h6 class="table-opening-table-date" v-else>-</h6>
          </div>
        </div>
      </div>
      <div id="no-open-tables-message-container" v-else>
        <h5>{{labels.tableOpenings.noOpenTablesRightNow[language]}}</h5>
      </div>
    </div>
    <div
      @click="onMaskClick"
      :class="{
        mask:
          isEntranceOpen ||
          isLanguageModalOpen
      }"
    ></div>
    <PoweredByFooter v-if="!isLoading"></PoweredByFooter>
    <OrdersOfOpenTableModal
      ref="ordersOfOpenTableComponent"
      v-bind:class="{ hide: !isTableOrdersModalOpen}"
      :isFromHistoryScreen="false"
      :tableOpening="selectedTableOpening"
      :loadingOrders="loadingOrders"
      :ordersOfSelectedTableOpening="ordersOfSelectedTableOpening"
      :ordersConcatedNote="ordersConcatedNote"
      :errorWhileLoadingOrders="errorWhileLoadingOrders"
      :hotelRooms="hotelRooms"
      :typeOfTableOpenings="typeOfTableOpenings"
      :isHotel="store && store.hotel"
      :assignedTablesOnly="store && store.assignedTablesOnly"
      :waiterIds="waiterIds"
      :waiters="waitersToShow"
      @reload-tables-screen="loadTablesScreen"
      @update-selected-tableOpening="updateSelectedTableOpening"
      @set-selected-tableOpening="setSelectedTableOpening"
      :authToken="authToken"
      :sections="sections"
      :jwt="jwt"
      :tempReceiptsOfSelectedTableOpening="tempReceiptsOfSelectedTableOpening"
      :currentUserId="currentUserId"
      :waiterOfcurrentUser="waiterOfcurrentUser"
      :tablesUserIsAbleToTransfer="tablesUserIsAbleToTransfer"
      :adminAccounts="adminAccounts"
    ></OrdersOfOpenTableModal>
  </div>
</template>

<script>
import Store from "../Store";
import StoreApi from "../../api/stores";
import UserApi from "../../api/user";
import OrderApi from "../../api/order";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import ProfileDropdown from "../ProfileDropdown";
import EnterPrompt from "../EnterPrompt";
import LanguageSelect from "../LanguageSelect";
import Button from "../Button";
import BackToServices from "../BackToServices.vue";
import OrdersOfOpenTableModal from "../OrdersOfOpenTableModal";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import _ from "lodash";

import Footer from "../Footer.vue";
import PoweredByFooter from "../PoweredByFooter.vue";

export default {
  name: "TablesScreen",
  components: {
    Store,
    ProfileDropdown,
    EnterPrompt,
    Loading,
    LanguageSelect,
    Button,
    BackToServices,
    Footer,
    OrdersOfOpenTableModal,
    PoweredByFooter,
    ClipLoader
  },
  props: [""],
  data() {
    return {
      store: undefined,
      isLoading: true,
      generatingTempReceipts: false,
      printingOpenTempsReport: false,
      error: false,
      errorMessage: "",
      successfullAction: false,
      successMessage: "",
      from: undefined,
      fromRouteName: '',
      shouldShowEnterPrompt: false,
      isApplication: false,
      isAbleToChangeLanguage: true,
      sections: [],
      selectedSection: "ALL",
      typeOfTableOpenings: "TABLES",
      selectedDepartmentId: 0,
      tableOpenings: [],
      tables: [],
      refreshTablesInterval: null,
      selectedTableOpening: null,
      loadingOrders: false,
      errorWhileLoadingOrders: false,
      hotelRooms: [],
      sectionsOfUser: [],
      ordersOfSelectedTableOpening: [],
      ordersConcatedNote: "",
      tempReceiptsOfSelectedTableOpening: [],
      tableTypesToFetchOpenings: [],
      tableToSearch: null,
      showOnlyOpenTables: true,
      waiterIds: [],
      waiterOfcurrentUser: null,
      isAtLeastOneRestaurantPublishesReceipts: false,
      storesWithDefaultSelfService: [139, 144] //TODO this is hack solution should come from back-end
    };
  },
  watch: {
    isTableOrdersModalOpen: function (newVal, oldVal) {
      let htmlElement = document.querySelector("html");
      if (newVal == true) {
        htmlElement.style.overflow = "hidden";
      } else {
        htmlElement.style.overflow = "auto";
      }
    }
  },
  created() {
  },
  async mounted() {
    let storeId = this.$router.currentRoute.params.storeId;
    this.$store.dispatch("setStoreId", storeId);
    if (this.$route.name == 'open-rooms') {
      this.tableTypesToFetchOpenings.push("HOTEL_ROOM");
    } else {
      this.tableTypesToFetchOpenings = this.storesWithDefaultSelfService.includes(storeId) ? ["QR_SELF_SERVICE", "SELF_SERVICE_POS"] : ["TABLE", "BEACH_CHAIR", "TABLE_AT_HOTEL", "UMBRELLA_AT_HOTEL", "DELIVERY", "DELIVERY_TABLE"];
      this.typeOfTableOpenings = this.storesWithDefaultSelfService.includes(storeId) ? "SELF_SERVICE" : "TABLES";
    }
    try {
      await this.loadTablesScreen();

      //Below is hack solution for a bug that iphones have that scroll sometimes is stuck
      setTimeout(() => {
        this.showOnlyOpenTables = false;
      }, 150);

      if (this.$route.name == 'open-tables') {
        this.refreshTablesInterval = setInterval(async () => {
          await this.refreshOpenTables();
        }, 31000);
      }

      this.scrollDownPixels(2)
    } catch (error) {
      this.isLoading = false;

      this.$store.dispatch("setUserData", {});
      let queryObject = null;
      if (this.$route.query && this.$route.query.clientId != undefined) {
        queryObject = { clientId: this.$route.query.clientId };
      }

      this.$router.push({ name: "services", params: { tableId: this.tableId }, query: queryObject });
    }

  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRouteName = from.name;
      vm.from = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEntranceOpen) {
      this.closeEntrance();
      //below is needed for same reason as above
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isLanguageModalOpen) {
      this.$store.dispatch("closeLanguageModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isTableOrdersModalOpen) {
      try {
        this.$refs.ordersOfOpenTableComponent.setResetOfStateOnOrdersChange(true);
      } catch (error) {
        console.log("Could not stop reset of state on orders change");
      }
      this.$store.dispatch("closeTableOrdersModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else {
      next();
    }
  },
  beforeDestroy() {
    if (this.selectedDepartmentId != this.restaurantsWithTableOpenings[0].id) {
      this.$store.dispatch("setTablesWithOpenings", [])
    }
    clearInterval(this.refreshTablesInterval);
  },
  computed: {
    tableId() {
      return this.$store.getters.getTableId;
    },

    tablesWithOpenings() {
      return this.$store.getters.getTablesWithOpenings;
    },

    restaurantsWithTableOpenings() {
      return this.$store.getters.getRestaurantsWithTableOpenings;
    },

    waiters() {
      return this.$store.getters.getWaiters;
    },

    waitersToShow() {
      if (this.currentUserId && this.currentUserId == 166) {
        return this.$store.getters.getWaiters;
      }
      return this.$store.getters.getWaiters.filter(waiter => waiter.userId != 166);
    },

    cardTerminals() {
      return this.$store.getters.getCardTerminals;
    },

    tablesUserIsAbleToTransfer() {
      if (this.store && this.store.assignedTablesOnly && this.typeOfTableOpenings == 'TABLES' && (this.waiterOfcurrentUser == null || !this.waiterOfcurrentUser.ableToViewAllOpenTables)) {
        let tables = this.tableOpenings.filter(tableOpening => tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId)).map(tableOpening => tableOpening.table);
        tables = this.sectionsOfUser.length > 0 ? tables.filter(table => this.sectionsOfUser.includes(table.familySection)) : tables;
        return tables;
      }

      if (this.store && this.store.assignedTablesOnly && this.typeOfTableOpenings == 'TABLES' && this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToViewAllOpenTables && !this.waiterOfcurrentUser.ableToEditOtherOpenTables) {
        let tables = this.tableOpenings.filter(tableOpening => tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId)).map(tableOpening => tableOpening.table);
        tables = this.sectionsOfUser.length > 0 ? tables.filter(table => this.sectionsOfUser.includes(table.familySection)) : tables;
        return tables;
      }

      if (this.store && this.store.assignedTablesOnly && this.typeOfTableOpenings == 'TABLES' && this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToViewAllOpenTables) {
        let tables = this.tableOpenings.filter(tableOpening => tableOpening.id == null || this.waiterIds.includes(tableOpening.openingUserId)).map(tableOpening => tableOpening.table);
        tables = this.sectionsOfUser.length > 0 ? tables.filter(table => this.sectionsOfUser.includes(table.familySection)) : tables;
        return tables;
      }

      if (this.typeOfTableOpenings == 'TABLES' && this.sectionsOfUser.length > 0) {
        let tables = this.tableOpenings.filter(tableOpening => this.sectionsOfUser.includes(tableOpening.table.familySection)).map(tableOpening => tableOpening.table);
        return tables;
      }

      let tables = []
      return tables;
    },

    tableOpeningsToShow() {

      if (this.store.assignedTablesOnly && this.typeOfTableOpenings == 'TABLES' && (this.waiterOfcurrentUser == null || !this.waiterOfcurrentUser.ableToViewAllOpenTables)) {
        if (this.selectedSection == 'ALL') {
          if (this.tableToSearch == null || this.tableToSearch.trim().length == 0) {
            if (this.showOnlyOpenTables) {
              let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.currentlyOpen && (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
              return tableOpeningsToShow;
            }
            let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
            return tableOpeningsToShow;
          } else {
            let filteredTables = this.tableOpenings.filter(tableOpening => {
              if (tableOpening.alias != null && tableOpening.alias.trim().length > 0) {
                if (this.showOnlyOpenTables) {
                  return tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen && (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId));
                }
                return tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && (tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
              } else {
                if (this.showOnlyOpenTables) {
                  return tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen && (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId));
                }
                return tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && (tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
              }
            });
            return filteredTables;
          }
        } else {
          if (this.tableToSearch == null || this.tableToSearch.trim().length == 0) {
            if (this.showOnlyOpenTables) {
              let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.table.familySection == this.selectedSection && tableOpening.currentlyOpen && (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
              return tableOpeningsToShow;
            }
            let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.table.familySection == this.selectedSection && (tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId))));
            return tableOpeningsToShow;
          } else {
            let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => {
              if (tableOpening.alias != null && tableOpening.alias.trim().length > 0) {
                if (this.showOnlyOpenTables) {
                  return tableOpening.table.familySection == this.selectedSection && tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen && (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId));
                }
                return tableOpening.table.familySection == this.selectedSection && tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && (tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
              } else {
                if (this.showOnlyOpenTables) {
                  return tableOpening.table.familySection == this.selectedSection && tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen && (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId));
                }
                return tableOpening.table.familySection == this.selectedSection && tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && (tableOpening.id == null || (tableOpening.openingUserId == this.currentUserId || !this.waiterIds.includes(tableOpening.openingUserId)));
              }
            });
            return tableOpeningsToShow;
          }
        }

      } else { //below is when everyone can see all tables

        if (this.selectedSection == 'ALL') {
          if (this.tableToSearch == null || this.tableToSearch.trim().length == 0) {
            if (this.showOnlyOpenTables) {
              let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.currentlyOpen);
              return tableOpeningsToShow;
            }
            return this.tableOpenings;
          } else {
            let filteredTables = this.tableOpenings.filter(tableOpening => {
              if (tableOpening.alias != null && tableOpening.alias.trim().length > 0) {
                if (this.showOnlyOpenTables) {
                  return tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen;
                }
                return tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim());
              } else {
                if (this.showOnlyOpenTables) {
                  return tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen;
                }
                return tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim());
              }
            });
            return filteredTables;
          }
        } else {
          if (this.tableToSearch == null || this.tableToSearch.trim().length == 0) {
            if (this.showOnlyOpenTables) {
              let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.table.familySection == this.selectedSection && tableOpening.currentlyOpen);
              return tableOpeningsToShow;
            }
            let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => tableOpening.table.familySection == this.selectedSection);
            return tableOpeningsToShow;
          } else {
            let tableOpeningsToShow = this.tableOpenings.filter(tableOpening => {
              if (tableOpening.alias != null && tableOpening.alias.trim().length > 0) {
                if (this.showOnlyOpenTables) {
                  return tableOpening.table.familySection == this.selectedSection && tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen;
                }
                return tableOpening.table.familySection == this.selectedSection && tableOpening.alias.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim());
              } else {
                if (this.showOnlyOpenTables) {
                  return tableOpening.table.familySection == this.selectedSection && tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim()) && tableOpening.currentlyOpen;
                }
                return tableOpening.table.familySection == this.selectedSection && tableOpening.table.tableNumber.toUpperCase().trim().startsWith(this.tableToSearch.toUpperCase().trim());
              }

            });
            return tableOpeningsToShow;
          }
        }
      }
    },

    tableOpeningsToShowTotal() {
      let totalOfOpenTables = 0;
      this.tableOpeningsToShow.forEach(tableOpening => {
        let totalPriceOfTableOpening = this.getTotalAmountOfTableOpening(tableOpening);
        totalOfOpenTables = totalOfOpenTables + totalPriceOfTableOpening;
      })

      return totalOfOpenTables;
    },

    isEntranceOpen() {
      return this.$store.getters.getSlideEntranceIn;
    },

    isTableOrdersModalOpen() {
      return this.$store.state.tableOrdersModalOpen;
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    isLanguageModalOpen() {
      return this.$store.getters.isLanguageModalOpen;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    currentGreekDate() {
      return this.$store.getters.getCurrentGreekDate;
    },

    authToken() {
      return this.$store.getters.getUserAuthToken;
    },

    jwt() {
      return this.$store.getters.getUserJWT;
    },

    currentUserId() {
      return this.$store.getters.getUserId;
    },

    restaurantsWithTheirTables() {
      return this.$store.getters.getRestaurantsWithTheirTables;
    },

    adminAccounts() {
      return this.$store.getters.getAdminAccounts;
    },

    userCanPanicButton() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.selectedDepartmentId & adminAccount.ableToPanicButton);
    },

    userCanSeeHistory() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.selectedDepartmentId & adminAccount.ableToSeeHistory & adminAccount.ableToSeeMobileReports);
    },

    userCanPrintOpenTempsReport() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.selectedDepartmentId & adminAccount.ableToPrintTempsReport);
    },

    storeName() {
      if (this.store) {
        return this.store.names && this.store.names.translation[this.language]
          ? this.store.names.translation[this.language].name
          : this.store.name;
      }
    },

    title() {
      if (this.store) {
        return `${this.labels.titles.openTables[this.language]} - ${this.storeName} | Fluter`;
      } else {
        return `${this.labels.titles.openTables[this.language]} | Fluter`;
      }
    },
  },

  methods: {

    onMaskClick: function () {
      if (this.isEntranceOpen) {
        this.closeEntrance();
      } else if (this.isLanguageModalOpen) {
        this.$store.dispatch("closeLanguageModal");
      }
    },

    toggleShowOnlyOpenTables() {
      this.showOnlyOpenTables = !this.showOnlyOpenTables;
    },

    getMinimumPercentage(tableOpening) {
      try {
        const percentage = (tableOpening.totalPrice / tableOpening.minimumConsumption) * 100;
        return Math.min(percentage, 100);
      } catch (error) {
        return 0;
      }
    },

    async onTypeOfTableOpeningChange() {
      if (this.typeOfTableOpenings == 'TABLES') {
        this.tableTypesToFetchOpenings = ["TABLE", "BEACH_CHAIR", "TABLE_AT_HOTEL", "UMBRELLA_AT_HOTEL", "DELIVERY", "DELIVERY_TABLE"];
      } else {
        this.tableTypesToFetchOpenings = ["QR_SELF_SERVICE", "SELF_SERVICE_POS"];
      }
      this.showOnlyOpenTables = false;
      this.selectedSection = "ALL";
      this.tableToSearch = null;
      await this.loadTablesScreen();
      //Below is hack solution for a bug that iphones have that scroll sometimes is stuck
      this.showOnlyOpenTables = true;
      setTimeout(() => {
        this.showOnlyOpenTables = false;
      }, 150);
    },

    closeEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceOut");

      this.$store.dispatch("shouldNotSlideEntranceIn");

      setTimeout(() => {
        this.$store.dispatch("resetEntranceState");
        this.$store.dispatch("setEntranceMessage", "");

        this.$store.dispatch("resetVerificationState");
        this.$store.dispatch("setVerificationMessage", "");
      }, 850);
    },

    initiateEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceIn");
    },

    setSelectedSection(section) {
      this.selectedSection = section;
    },

    getTotalAmountOfTableOpening(tableOpening) {
      if (tableOpening.minimumConsumption == 0) {
        return tableOpening.totalPrice;
      }
      if (tableOpening.minimumConsumption > 0 && tableOpening.totalPrice == 0) {
        return 0;
      }
      let totalAmountToShow = tableOpening.totalPrice > tableOpening.minimumConsumption ? tableOpening.totalPrice : tableOpening.minimumConsumption;
      return totalAmountToShow;
    },

    amountRemainingToBePaid(tableOpening) {
      if (tableOpening.minimumConsumption == 0) {
        let amountThatRemains = tableOpening.totalPrice - tableOpening.amountPayedByCard - tableOpening.amountPayedByCash - tableOpening.amountChargedToRoom;
        amountThatRemains = amountThatRemains < 0 ? 0 : amountThatRemains;
        return (amountThatRemains).toFixed(2);
      }

      if (tableOpening.minimumConsumption > 0 && tableOpening.totalPrice == 0) {
        let amount = 0;
        return amount.toFixed(2);
      }

      let totalPrice = tableOpening.totalPrice <= tableOpening.minimumConsumption ? tableOpening.minimumConsumption : tableOpening.totalPrice;
      let amountThatRemains = totalPrice - tableOpening.amountPayedByCard - tableOpening.amountPayedByCash - tableOpening.amountChargedToRoom;
      amountThatRemains = amountThatRemains < 0 ? 0 : amountThatRemains;
      return (amountThatRemains).toFixed(2);
    },

    async selectDepartment(departmentId) {
      this.selectedDepartmentId = departmentId;
      this.isLoading = true;
      this.selectedSection = 'ALL';
      this.sections = [];
      this.showOnlyOpenTables = false;
      this.$store.dispatch("setTablesWithOpenings", [])
      if (this.$route.name == 'open-tables' && this.typeOfTableOpenings == 'TABLES') {
        let currentOpenTables = [];
        this.tables = [];

        let apiResponses2 = await Promise.all([StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false), StoreApi.getTablesWithOpeningsForRestaurant(this.store.id, this.selectedDepartmentId)]).then(data => {
          return {
            tableOpenings: data[0],
            tablesWithOpenings: data[1]
          }
        });

        let selectedDepartment = this.restaurantsWithTableOpenings.find(restaurantWithOpenings => restaurantWithOpenings.id == this.selectedDepartmentId);
        currentOpenTables = apiResponses2.tableOpenings;
        this.tables = apiResponses2.tablesWithOpenings;
        this.$store.dispatch("setTablesWithOpenings", apiResponses2.tablesWithOpenings)

        let closedAndOpenTables = [];

        let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.selectedDepartmentId);
        this.sectionsOfUser = adminAcountOfUserForCurrentRestaurant.sectionsOfUser == null || adminAcountOfUserForCurrentRestaurant.sectionsOfUser.trim().length == 0 ? [] : adminAcountOfUserForCurrentRestaurant.sectionsOfUser.split(",");
        this.sections = this.sectionsOfUser.length > 0 ? this.sectionsOfUser : this.sections;

        for (let table of this.tables) {

          if (this.sectionsOfUser.length > 0 && !this.sectionsOfUser.includes(table.familySection)) {
            continue;
          }

          if (this.sectionsOfUser.length == 0 && table.familySection != null && table.familySection.trim().length > 0 && !this.sections.includes(table.familySection)) {
            this.sections.push(table.familySection);
          }

          let openTableOpening = currentOpenTables.find(tableOpening => tableOpening.table.id == table.id);
          if (openTableOpening) {
            closedAndOpenTables.push(openTableOpening);
          } else {
            let closedTableOpening = {
              alias: "",
              amountCanceled: 0,
              amountChargedToRoom: 0,
              amountOfCardReceipts: 0,
              amountOfCashReceipts: 0,
              amountOfOnCreditReceipts: 0,
              amountOfSelfDeliveryReceipts: 0,
              amountOfVat: 0,
              amountPayedByCard: 0,
              amountPayedByCash: 0,
              amountTreated: 0,
              closingDate: null,
              currentlyOpen: false,
              dailyTableOpeningNumber: 0,
              id: null,
              note: null,
              allOrdersExecuted: false,
              originTableTitle: null,
              minimumConsumption: 0,
              nameOfUser: null,
              openingUserId: null,
              openingDate: null,
              paymentType: null,
              restaurant: selectedDepartment,
              table: table,
              totalDailyOpeningNumber: 0,
              totalPrice: 0
            }
            closedAndOpenTables.push(closedTableOpening);
          }
        }

        for (let tableOpening of currentOpenTables) {
          let tableOpeningExistsInClosedAndOpen = closedAndOpenTables.some(existingTableOpening => existingTableOpening.id == tableOpening.id);
          if (!tableOpeningExistsInClosedAndOpen && (this.sectionsOfUser.length == 0 || this.sectionsOfUser.includes(tableOpening.table.familySection))) {
            closedAndOpenTables.unshift(tableOpening);
          }
        }
        this.tableOpenings = closedAndOpenTables;

      } else if (this.$route.name == 'open-rooms') {
        let apiResponses = await Promise.all([StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false), StoreApi.getHotelRoomSections(this.store.id)]).then(data => {
          return {
            tableOpenings: data[0],
            sections: data[1]
          }
        });
        this.tableOpenings = apiResponses.tableOpenings;
        this.sections = apiResponses.sections;
      } else {
        this.tableOpenings = await StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false);
      }
      this.isLoading = false;
      //Below is hack solution for a bug that iphones have that scroll sometimes is stuck
      this.showOnlyOpenTables = true;
      setTimeout(() => {
        this.showOnlyOpenTables = false;
        this.scrollDownPixels(2);
      }, 150);
    },

    async generateNonPublishedTempReceipts(printTemps) {

      if (!this.generatingTempReceipts) {
        this.error = false;
        this.errorMessage = "";
        this.successfullAction = false;
        this.successMessage = "";

        let msg = printTemps ? "Είστε σίγουρος για την δημιουργία όλων των προσωρινών αποδείξεων που δεν έχετε έκδωσει, και να γίνει *ΑΜΕΣΗ ΕΚΤΥΠΩΣΗ* μαζί;" : "Είστε σίγουρος για την δημιουργία όλων των προσωρινών αποδείξεων που δεν έχετε έκδωσει, *ΧΩΡΙΣ* άμεση εκτύπωση;"

        this.$confirm({
          message: msg,
          button: {
            yes: 'Ναι',
            no: 'Όχι'
          },
          callback: async confirm => {
            if (confirm) {
              this.generatingTempReceipts = true;
              let response = await StoreApi.createAllNonPublishedTempReceipts(this.selectedDepartmentId, printTemps, this.currentUserId, this.authToken, this.jwt);
              if (response.error) {
                this.generatingTempReceipts = false;
                this.error = true;
                this.errorMessage = "Κάτι πήγε λάθος κατά την έκδοση των προσωρινών αποδείξεων τις οποίες δεν έιχατε εκδώσει.";
                setTimeout(() => {
                  this.error = false;
                  this.errorMessage = "";
                }, 5000);
              } else {
                this.generatingTempReceipts = false;
                this.$confirm({
                  message: `Οι προσωρινές αποδείξεις εκδόθηκαν επιτυχώς.`,
                  button: {
                    yes: 'ΟΚ'
                  },
                  callback: async confirm => {
                    if (confirm) {
                      await this.loadTablesScreen();
                    } else {
                      await this.loadTablesScreen();
                    }
                  }
                });
              }
            }
          }
        });
      }

    },

    async printTempReceiptsReport() {

      if (!this.printingOpenTempsReport) {
        this.$confirm({
          message: "Είστε σίγουρος για την εκτύπωση αναφοράς των ανοιχτών προσωρινών αποδείξεων;",
          button: {
            yes: 'Ναι',
            no: 'Όχι'
          },
          callback: async confirm => {
            if (confirm) {
              this.printingOpenTempsReport = true;
              await StoreApi.sendTempReceiptsReport(this.selectedDepartmentId, this.authToken, this.jwt);
              setTimeout(() => {
                this.printingOpenTempsReport = false;
              }, 1800);
            }
          }
        });
      }

    },

    async openTableOrders(tableOpening) {

      if (tableOpening.currentlyOpen && this.store.assignedTablesOnly && tableOpening.openingUserId != null && this.waiterOfcurrentUser.ableToViewAllOpenTables && !this.waiterOfcurrentUser.ableToEditOtherOpenTables && this.waiterOfcurrentUser.userId != tableOpening.openingUserId) {
        return;
      }

      //this is made for the pull to refresh not to work
      //on the webview while the modal is open if the screen was at the top
      this.scrollDownPixels(8)

      this.ordersConcatedNote = "";
      this.ordersOfSelectedTableOpening = [];
      this.tempReceiptsOfSelectedTableOpening = [];
      this.selectedTableOpening = tableOpening;
      if (tableOpening.id == null) {
        this.$store.dispatch("openTableOrdersModal");
      } else {
        this.loadingOrders = true;
        this.errorWhileLoadingOrders = false;
        this.$store.dispatch("openTableOrdersModal");

        let apiResponses = await Promise.all([OrderApi.getOrdersByTableOpening(tableOpening.id, this.selectedDepartmentId, this.authToken, this.jwt), StoreApi.fetchTempReceiptsForTableOpening(tableOpening.id, this.selectedDepartmentId, this.authToken, this.jwt)]).then(data => data);
        if (apiResponses[0].error || apiResponses[1].error) {
          this.errorWhileLoadingOrders = true;
        } else {
          let commentOfAllOrders = "";
          apiResponses[0].forEach(order => {
            if (order.comment != null && order.comment.trim().length > 0)
              if (commentOfAllOrders == "") {
                commentOfAllOrders = commentOfAllOrders + order.comment;
              } else {
                commentOfAllOrders = commentOfAllOrders + ", " + order.comment;
              }
          });
          this.ordersConcatedNote = commentOfAllOrders;
          let ordersOfOpenTable = apiResponses[0];
          try {
            await this.calibrateTableOpeningIfNeeded(tableOpening, ordersOfOpenTable);
          } catch (error) {
            console.log("Could not calibrate table opening")
          }
          this.ordersOfSelectedTableOpening = ordersOfOpenTable;
          this.tempReceiptsOfSelectedTableOpening = apiResponses[1];
        }
        this.loadingOrders = false;
      }
    },

    async calibrateTableOpeningIfNeeded(tableOpening, ordersOfOpenTable) {
      let isTableOpeningPricesDeviate = this.isTableOpeningPricesDeviate(tableOpening, ordersOfOpenTable)

      if (isTableOpeningPricesDeviate) {
        let calibratedTableOpening = await StoreApi.calibrate(tableOpening.id, this.selectedDepartmentId, this.authToken, this.jwt);

        const index = this.tableOpenings.findIndex(opening => opening.id === calibratedTableOpening.id);
        if (index != -1) {
          this.tableOpenings.splice(index, 1, calibratedTableOpening);
        }
        this.selectedTableOpening = calibratedTableOpening;
      }
    },

    isTableOpeningPricesDeviate(tableOpening, ordersOfOpenTable) {

      if (!tableOpening.currentlyOpen) {
        return false;
      }

      let pricesOfOpenTableFromOrders = this.getTableOpeningPricesFromOrders(ordersOfOpenTable);
      let pricesDeviate = false;

      if (pricesOfOpenTableFromOrders.amountPayedByCash != tableOpening.amountPayedByCash && (pricesOfOpenTableFromOrders.amountPayedByCash - tableOpening.amountPayedByCash > 0.02 || tableOpening.amountPayedByCash - pricesOfOpenTableFromOrders.amountPayedByCash > 0.02)) {
        pricesDeviate = true;
      }

      if (pricesOfOpenTableFromOrders.amountPayedByCard != tableOpening.amountPayedByCard && (pricesOfOpenTableFromOrders.amountPayedByCard - tableOpening.amountPayedByCard > 0.02 || tableOpening.amountPayedByCard - pricesOfOpenTableFromOrders.amountPayedByCard > 0.02)) {
        pricesDeviate = true;
      }

      if (pricesOfOpenTableFromOrders.amountChargedToRoom != tableOpening.amountChargedToRoom && (pricesOfOpenTableFromOrders.amountChargedToRoom - tableOpening.amountChargedToRoom > 0.02 || tableOpening.amountChargedToRoom - pricesOfOpenTableFromOrders.amountChargedToRoom > 0.02)) {
        pricesDeviate = true;
      }

      if (pricesOfOpenTableFromOrders.amountTreated != tableOpening.amountTreated && (pricesOfOpenTableFromOrders.amountTreated - tableOpening.amountTreated > 0.02 || tableOpening.amountTreated - pricesOfOpenTableFromOrders.amountTreated > 0.02)) {
        pricesDeviate = true;
      }

      if (pricesOfOpenTableFromOrders.amountCanceled != tableOpening.amountCanceled && (pricesOfOpenTableFromOrders.amountCanceled - tableOpening.amountCanceled > 0.02 || tableOpening.amountCanceled - pricesOfOpenTableFromOrders.amountCanceled > 0.02)) {
        pricesDeviate = true;
      }

      if (pricesOfOpenTableFromOrders.totalPrice != tableOpening.totalPrice && (pricesOfOpenTableFromOrders.totalPrice - tableOpening.totalPrice > 0.02 || tableOpening.totalPrice - pricesOfOpenTableFromOrders.totalPrice > 0.02)) {
        pricesDeviate = true;
      }

      return pricesDeviate;
    },

    getTableOpeningPricesFromOrders(orders) {
      let amountPayedByCash = 0;
      let amountPayedByCard = 0;
      let amountChargedToRoom = 0;
      let amountTreated = 0;
      let amountCanceled = 0;
      let totalPrice = 0;

      for (let order of orders) {
        order.products.forEach(orderContent => {
          let totalSubselectionPrice = 0;
          orderContent.productSubselections.forEach(productSubselection => {
            totalSubselectionPrice = totalSubselectionPrice + productSubselection.price;
          });

          if (orderContent.quantityPayedBeforeClose > 0) {
            amountPayedByCash = amountPayedByCash + (orderContent.price + totalSubselectionPrice) * orderContent.quantityPayedBeforeClose;
          }

          if (orderContent.quantityPayedByCardBeforeClose > 0) {
            amountPayedByCard = amountPayedByCard + (orderContent.price + totalSubselectionPrice) * orderContent.quantityPayedByCardBeforeClose;
          }

          if (orderContent.quantityChargedToRoom > 0) {
            amountChargedToRoom = amountChargedToRoom + (orderContent.price + totalSubselectionPrice) * orderContent.quantityChargedToRoom;
          }

          if (orderContent.quantityTreated > 0) {
            amountTreated = amountTreated + (orderContent.price + totalSubselectionPrice) * orderContent.quantityTreated;
          }

          if (orderContent.quantityCanceled > 0) {
            amountCanceled = amountCanceled + (orderContent.price + totalSubselectionPrice) * orderContent.quantityCanceled;
          }

          let quantityForTotalPrice = orderContent.quantity - orderContent.quantityCanceled - orderContent.quantityTreated;
          totalPrice = totalPrice + (orderContent.price + totalSubselectionPrice) * quantityForTotalPrice;
        });
      }

      let pricesOfOpenTable = {
        totalPrice: totalPrice,
        amountPayedByCash: amountPayedByCash,
        amountPayedByCard: amountPayedByCard,
        amountChargedToRoom: amountChargedToRoom,
        amountTreated: amountTreated,
        amountCanceled: amountCanceled
      };

      return pricesOfOpenTable;
    },

    scrollDownPixels(pixels) {
      try {
        window.scrollTo(0, window.scrollY + pixels);
      } catch (error) {
        console.log("Could not scroll");
      }
    },

    setSelectedTableOpening(tableOpeningUpdated) {
      let index = this.tableOpenings.findIndex(tableOpening => tableOpening.id === tableOpeningUpdated.id);
      if (index != -1) {
        this.tableOpenings.splice(index, 1, tableOpeningUpdated);
      }
      this.selectedTableOpening = tableOpeningUpdated;
    },

    async updateSelectedTableOpening(tableOpening) {
      const index = this.tableOpenings.findIndex(opening => opening.id === tableOpening.id);
      if (index != -1) {
        this.tableOpenings.splice(index, 1, tableOpening);
      }
      await this.openTableOrders(tableOpening);
    },

    findServiceName(userId) {
      let waiter = this.waiters.find(waiter => waiter.userId == userId);
      if (waiter != null) {
        return waiter.name;
      }
      return "-";
    },

    // THIS REFRESHES ONLY FOR TABLES -> NOT FOR HOTEL_ROOMS
    async refreshOpenTables() {
      let currentOpenTables = await StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, true);
      if (currentOpenTables && currentOpenTables.error) {
        console.log("error during fetching open tables on refresh")
      } else {
        if (this.typeOfTableOpenings == 'SELF_SERVICE') {
          this.tableOpenings = currentOpenTables;
        } else {
          let selectedDepartment = this.restaurantsWithTableOpenings.find(restaurantWithOpenings => restaurantWithOpenings.id == this.selectedDepartmentId);
          let closedAndOpenTables = [];

          let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.selectedDepartmentId);
          this.sectionsOfUser = adminAcountOfUserForCurrentRestaurant.sectionsOfUser == null || adminAcountOfUserForCurrentRestaurant.sectionsOfUser.trim().length == 0 ? [] : adminAcountOfUserForCurrentRestaurant.sectionsOfUser.split(",");
          this.sections = this.sectionsOfUser.length > 0 ? this.sectionsOfUser : this.sections;

          for (let table of this.tables) {

            if (this.sectionsOfUser.length > 0 && !this.sectionsOfUser.includes(table.familySection)) {
              continue;
            }

            let openTableOpening = currentOpenTables.find(tableOpening => tableOpening.table.id == table.id);
            if (openTableOpening) {
              closedAndOpenTables.push(openTableOpening);
            } else {
              let closedTableOpening = {
                alias: "",
                amountCanceled: 0,
                amountChargedToRoom: 0,
                amountOfCardReceipts: 0,
                amountOfCashReceipts: 0,
                amountOfOnCreditReceipts: 0,
                amountOfOpenTempReceipts: 0,
                amountOfSelfDeliveryReceipts: 0,
                amountOfVat: 0,
                amountPayedByCard: 0,
                amountPayedByCash: 0,
                amountTreated: 0,
                closingDate: null,
                currentlyOpen: false,
                note: null,
                allOrdersExecuted: false,
                originTableTitle: null,
                dailyTableOpeningNumber: 0,
                id: null,
                minimumConsumption: 0,
                nameOfUser: null,
                openingDate: null,
                paymentType: null,
                restaurant: selectedDepartment,
                table: table,
                totalDailyOpeningNumber: 0,
                totalPrice: 0
              }
              closedAndOpenTables.push(closedTableOpening);
            }
          }

          for (let tableOpening of currentOpenTables) {
            let tableOpeningExistsInClosedAndOpen = closedAndOpenTables.some(existingTableOpening => existingTableOpening.id == tableOpening.id);
            if (!tableOpeningExistsInClosedAndOpen && (this.sectionsOfUser.length == 0 || this.sectionsOfUser.includes(tableOpening.table.familySection))) {
              closedAndOpenTables.unshift(tableOpening);
            }
          }
          this.tableOpenings = closedAndOpenTables;
        }
      }

    },

    async loadTablesScreen() {
      this.isLoading = true;
      let storeId = this.$router.currentRoute.params.storeId;
      let tableId = this.$router.currentRoute.params.tableId;

      if (this.$route.params.store) {
        this.store = this.$route.params.store;
      } else if (!this.store) {
        this.store = await StoreApi.getStoreById(storeId);
      }

      if (this.store.hotel && this.hotelRooms.length == 0) {
        let hotelRooms = await StoreApi.getHotelizerListOfRooms(this.store.id);
        this.hotelRooms = hotelRooms;
      }
      this.$store.dispatch("setTableId", tableId)

      if (this.$route.name == 'open-rooms') {
        let apiResponses = await Promise.all([StoreApi.getRestaurantsWithRoomOpenings(this.store.id, this.authToken, this.jwt), StoreApi.getHotelRoomSections(this.store.id)]).then(data => {
          return {
            restaurantsWithOpenings: data[0],
            sections: data[1]
          }
        });
        this.$store.dispatch("setRestaurantsWithTableOpenings", apiResponses.restaurantsWithOpenings)
        this.sections = apiResponses.sections;
      } else if (this.restaurantsWithTableOpenings.length == 0) {
        let restaurantsWithTableOpenings = await StoreApi.getRestaurantsWithTableOpenings(this.store.id, this.authToken, this.jwt);
        this.$store.dispatch("setRestaurantsWithTableOpenings", restaurantsWithTableOpenings)
      }

      this.isAtLeastOneRestaurantPublishesReceipts = this.restaurantsWithTableOpenings.some(restaurantWithOpening => restaurantWithOpening.publishesReceipts);

      if (this.store.assignedTablesOnly && this.waiters.length == 0) {

        let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);

        if (this.isAtLeastOneRestaurantPublishesReceipts && this.cardTerminals.length == 0) {
          let apiResponses = await Promise.all([StoreApi.fetchActiveWaiters(restaurantIds, this.authToken, this.jwt), StoreApi.getCardTerminalsForRestaurants(restaurantIds, this.authToken, this.jwt)]).then(data => {
            return {
              waitersResponse: data[0],
              cardTerminalsResponse: data[1]
            }
          });

          this.$store.dispatch("setWaiters", apiResponses.waitersResponse)
          this.waiterIds = apiResponses.waitersResponse.map(waiter => waiter.userId);
          this.waiterOfcurrentUser = apiResponses.waitersResponse.find(waiter => waiter.userId == this.currentUserId);

          this.$store.dispatch("setCardTerminals", apiResponses.cardTerminalsResponse);

        } else {
          let waitersResponse = await StoreApi.fetchActiveWaiters(restaurantIds, this.authToken, this.jwt);
          this.$store.dispatch("setWaiters", waitersResponse)
          this.waiterIds = waitersResponse.map(waiter => waiter.userId);
          this.waiterOfcurrentUser = waitersResponse.find(waiter => waiter.userId == this.currentUserId);
        }

      } else {

        let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);

        if (this.isAtLeastOneRestaurantPublishesReceipts && this.cardTerminals.length == 0) {
          let cardTerminalsResponse = await StoreApi.getCardTerminalsForRestaurants(restaurantIds, this.authToken, this.jwt);
          this.$store.dispatch("setCardTerminals", cardTerminalsResponse)
        }

        this.waiterIds = this.waiters.map(waiter => waiter.userId);
        this.waiterOfcurrentUser = this.waiters.find(waiter => waiter.userId == this.currentUserId);
      }

      this.selectedDepartmentId = this.selectedDepartmentId == 0 ? this.restaurantsWithTableOpenings[0].id : this.selectedDepartmentId;

      if (this.$route.name == 'open-tables' && this.typeOfTableOpenings == 'TABLES') {
        let currentOpenTables = [];
        this.tables = [];
        let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);

        if (this.tablesWithOpenings.length == 0) {
          if (this.restaurantsWithTheirTables.length == 0 || this.adminAccounts.length == 0) {
            let apiResponses = await Promise.all([StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false), StoreApi.getTablesWithOpeningsOfRestaurants(storeId, restaurantIds), UserApi.getAdminAccountsOfLoggedInUser(restaurantIds, this.authToken, this.jwt)]).then(data => {
              return {
                tableOpenings: data[0],
                restaurantsWithTables: data[1],
                adminAccounts: data[2]
              }
            });
            currentOpenTables = apiResponses.tableOpenings;

            let restaurantWithTablesOfSelectedDepartment = apiResponses.restaurantsWithTables.find(restarauntTables => restarauntTables.restaurantId == this.selectedDepartmentId);
            let tablesOfSelectedDepartment = restaurantWithTablesOfSelectedDepartment ? restaurantWithTablesOfSelectedDepartment.tables : await StoreApi.getTablesWithOpeningsForRestaurant(this.store.id, this.selectedDepartmentId);

            this.tables = tablesOfSelectedDepartment;
            this.$store.dispatch("setTablesWithOpenings", tablesOfSelectedDepartment)

            this.$store.dispatch("setRestaurantsWithTheirTables", apiResponses.restaurantsWithTables)
          } else {
            let apiResponses = await Promise.all([StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false), StoreApi.getTablesWithOpeningsForRestaurant(this.store.id, this.selectedDepartmentId)]).then(data => {
              return {
                tableOpenings: data[0],
                tablesWithOpenings: data[1]
              }
            });
            currentOpenTables = apiResponses.tableOpenings;
            this.tables = apiResponses.tablesWithOpenings;
            this.$store.dispatch("setTablesWithOpenings", apiResponses.tablesWithOpenings)
          }
        } else {
          if (this.restaurantsWithTheirTables.length == 0 || this.adminAccounts.length == 0) {
            let apiResponses = await Promise.all([StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false), StoreApi.getTablesWithOpeningsOfRestaurants(storeId, restaurantIds), UserApi.getAdminAccountsOfLoggedInUser(restaurantIds, this.authToken, this.jwt)]).then(data => {
              return {
                tableOpenings: data[0],
                restaurantsWithTables: data[1],
                adminAccounts: data[2]
              }
            });
            currentOpenTables = apiResponses.tableOpenings;
            this.tables = this.tablesWithOpenings;
            this.$store.dispatch("setRestaurantsWithTheirTables", apiResponses.restaurantsWithTables)

          } else {
            currentOpenTables = await StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false);
            this.tables = this.tablesWithOpenings;
          }

        }

        let selectedDepartment = this.restaurantsWithTableOpenings.find(restaurantWithOpenings => restaurantWithOpenings.id == this.selectedDepartmentId);
        let closedAndOpenTables = [];

        let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.selectedDepartmentId);
        this.sectionsOfUser = adminAcountOfUserForCurrentRestaurant.sectionsOfUser == null || adminAcountOfUserForCurrentRestaurant.sectionsOfUser.trim().length == 0 ? [] : adminAcountOfUserForCurrentRestaurant.sectionsOfUser.split(",");
        this.sections = this.sectionsOfUser.length > 0 ? this.sectionsOfUser : this.sections;

        for (let table of this.tables) {

          if (this.sectionsOfUser.length > 0 && !this.sectionsOfUser.includes(table.familySection)) {
            continue;
          }

          if (this.sectionsOfUser.length == 0 && table.familySection != null && table.familySection.trim().length > 0 && !this.sections.includes(table.familySection)) {
            this.sections.push(table.familySection);
          }

          let openTableOpening = currentOpenTables.find(tableOpening => tableOpening.table.id == table.id);
          if (openTableOpening) {
            closedAndOpenTables.push(openTableOpening);
          } else {
            let closedTableOpening = {
              alias: "",
              amountCanceled: 0,
              amountChargedToRoom: 0,
              amountOfCardReceipts: 0,
              amountOfCashReceipts: 0,
              amountOfOnCreditReceipts: 0,
              amountOfOpenTempReceipts: 0,
              amountOfSelfDeliveryReceipts: 0,
              amountOfVat: 0,
              amountPayedByCard: 0,
              amountPayedByCash: 0,
              amountTreated: 0,
              closingDate: null,
              currentlyOpen: false,
              note: null,
              allOrdersExecuted: false,
              originTableTitle: null,
              dailyTableOpeningNumber: 0,
              id: null,
              minimumConsumption: 0,
              nameOfUser: null,
              openingDate: null,
              paymentType: null,
              restaurant: selectedDepartment,
              table: table,
              totalDailyOpeningNumber: 0,
              totalPrice: 0
            }
            closedAndOpenTables.push(closedTableOpening);
          }
        }

        for (let tableOpening of currentOpenTables) {
          let tableOpeningExistsInClosedAndOpen = closedAndOpenTables.some(existingTableOpening => existingTableOpening.id == tableOpening.id);
          if (!tableOpeningExistsInClosedAndOpen && (this.sectionsOfUser.length == 0 || this.sectionsOfUser.includes(tableOpening.table.familySection))) {
            closedAndOpenTables.unshift(tableOpening);
          }
        }

        this.tableOpenings = closedAndOpenTables;

      } else {
        this.tableOpenings = await StoreApi.getTableOpeningsForRestaurant(this.selectedDepartmentId, this.tableTypesToFetchOpenings, this.authToken, this.jwt, false);
      }

      if (this.restaurantsWithTheirTables.length == 0 || this.adminAccounts.length == 0) {
        let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
        let apiResponses3 = await Promise.all([StoreApi.getTablesWithOpeningsOfRestaurants(storeId, restaurantIds), UserApi.getAdminAccountsOfLoggedInUser(restaurantIds, this.authToken, this.jwt)]).then(data => {
          return {
            restaurantsWithTables: data[0],
            adminAccounts: data[1]
          }
        });
        let restaurantsWithTables = apiResponses3.restaurantsWithTables;
        this.$store.dispatch("setRestaurantsWithTheirTables", restaurantsWithTables)
      }

      let serviceName = {
        GRE: {
          name: this.$route.name == 'open-rooms' ? "Ανοιχτά δωμάτια" : "Ανοιχτά τραπέζια"
        },
        ENG: {
          name: this.$route.name == 'open-rooms' ? "Open rooms" : "Open tables"
        },
      };
      this.$store.dispatch("setServiceName", serviceName);
      this.isLoading = false;

      this.setTitle();
    },

    setTitle() {
      try {
        document.title = this.title;
      } catch (error) {
        console.log("Could not set title");
      }
    }
  },
};
</script>

<style scoped>
#tables-screen {
  margin: 0px;
  box-sizing: border-box;
  padding: 0px;
  overflow-x: hidden;
  background: #fcfcfc;
  min-height: 100vh;
  z-index: 0;
  overflow-x: hidden !important;
}

.error-message {
  margin-bottom: 0px;
  font-weight: 600;
  font-size: 15px;
  color: #d9534f;
}

.mt4 {
  margin-top: 4px !important;
}

.mb0 {
  margin-bottom: 0px !important;
}

.mb2 {
  margin-bottom: 2px !important;
}

.minimum-progress-wrapper {
  width: 120px;
  height: 8px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 2px;
  margin-bottom: 3px;
}

.minimum-progress {
  height: 100%;
  background: #00c1f1;
  transition: width 0.3s ease;
}

.success-message {
  margin-bottom: 0px;
  font-weight: 600;
  font-size: 15px;
  width: 90%;
  color: #198b4a;
}

#banner {
  position: relative;
  width: 100vw;
  height: 55vh;
  min-height: 220px;
}

#banner-image {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#store-info {
  position: absolute;
  top: 15%;
  right: 5%;
  width: 30%;
  min-width: 400px;
  background: white;
  border-radius: 18px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.36), 2px 2px 4px rgba(0, 0, 0, 0.48);
}

#store {
  cursor: unset;
}

.tables-container {
  min-height: 600px !important;
}

#select-department-container {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 0px 0 7.5px 0;
  color: black;
}

#name-of-connected-user {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #198b4a !important;
}

.label-and-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-content: flex-start;
  margin-top: 8px;
  margin-left: 8px;
}

#departments-container,
#sections-container {
  display: flex;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
  margin-top: 9px;
  margin-left: 8px;
}

.department-selection-button {
  padding: 5px 5px 5px 5px;
  border-radius: 4px;
  cursor: pointer;
  color: #004353;
  background-color: #ffffff;
  border: 1px solid #004353;
  font-size: 13px;
  font-weight: 600;
  margin-top: 0px;
  margin-right: 6px;
  white-space: nowrap;
}

.section-selection-button {
  padding: 5px 5px 5px 5px;
  border-radius: 4px;
  cursor: pointer;
  color: #198b4a;
  background-color: #ffffff;
  border: 1px solid #198b4a;
  font-size: 13px;
  font-weight: 600;
  margin-top: 0px;
  margin-right: 6px;
  white-space: nowrap;
}

.selected-section {
  color: #ffffff !important;
  background-color: #198b4a !important;
}

.selected-department {
  color: #ffffff !important;
  background-color: #004e61 !important;
  box-shadow: 0px 0px 4px 0px #004e61;
}

.department-title {
  font-size: 15px;
  font-weight: 700;
}

.open-tables-details-title {
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

#generate-non-publised-temp {
  padding: 2px 5px 3px 5px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: white;
  width: 28px;
  background-color: #f4a330;
  white-space: nowrap;
  margin-left: 8px;
}

.print-temps-panic-button {
  background-color: #f46830 !important;
}

#print-open-temps-report {
  padding: 2px 5px 3px 5px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: white;
  width: 28px;
  background-color: #007bff;
  white-space: nowrap;
  margin-left: 8px;
}

.switch {
  margin-left: 4px;
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  width: 30px !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.search-tables-input {
  background-color: white;
  font-size: 14px;
  border: 1px solid;
  border-color: rgb(183, 183, 183);
  padding: 2px 0px 2px 4px;
  border-radius: 4px;
  height: 25px;
  margin-left: 5px;
  width: 100px;
}

.label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

select {
  display: flex;
  align-self: center;
  justify-self: center;
  -webkit-appearance: auto !important;
  box-shadow: inset 0px 0px 2px rgba(116, 135, 150, 0.2),
    inset 1px 1px 2px rgba(116, 135, 150, 0.36);
  border-radius: 6px;
  margin-bottom: 0.5rem;
  margin-left: 7px;
  padding: 2px;
  color: #198b4a !important;
  font-weight: bold;
  background: #f7f7f7;
}
@media screen and (max-width: 800px) {
  select {
    font-size: 14.5px;
  }
}
@media screen and (max-width: 300px) {
  select {
    font-size: 12px;
  }
}

option {
  color: #198b4a !important;
  font-weight: 600;
}

@keyframes slideFromBottom {
  from {
    transform: translateY(45vh);
  }

  to {
    transform: translateY(0);
  }
}

#table-items {
  margin-left: 6px;
  margin-right: 2px;
  margin-top: 20px;
  margin-bottom: 5vh;
  width: 85vw;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: stretch;
  animation: slideFromBottom 0.15s forwards linear;
}

.table-opening-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.table-and-section-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.receipt-info-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  margin-right: 4px;
}

#no-open-tables-message-container {
  margin-top: 20px;
  margin-bottom: 5vh;
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  justify-content: center;
}

#no-open-tables-message-container > h5 {
  width: 85%;
  font-weight: 600;
  font-size: 15px;
  text-align: center;
}

.table-opening {
  flex: 50%;
  max-width: 47%;
  border: 1px solid;
  border-radius: 10px;
  border-color: #b1b1b1;
  box-shadow: 0px 0px 4px 0px #888888;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 4px;
}

.table-opening-table-header {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 4px;
  color: #10703a;
}

.temp-receipt-info-header {
  font-size: 13px;
  font-weight: 600;
  color: #006adb;
  margin-bottom: 0px !important;
}

.final-receipt-info-header {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 4px;
  color: #10703a;
}

.dark-table-header {
  color: #003340 !important;
}

.self-service-origin-table-header {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 0px;
  color: #003340;
}

.table-opening-section-header {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0px;
  color: #898989;
}

.darker-section-header {
  color: #7f7f7f !important;
}

.table-opening-note-header {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 0px;
  color: #c5097d;
}

.table-opening-no-note-header {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 0px;
  color: #5f5f5f;
}

.table-opening-service-header {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 0px;
  color: #003340;
}

.table-closed-header {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #003340;
}

.table-opening-table-total {
  color: #414141;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 0px;
}

.table-opening-remaining-total {
  color: #414141;
  margin-top: 0px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 2px;
}

.table-opening-minimum-remaining {
  color: #414141;
  margin-top: 0px;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 0px;
}

.table-opening-minimum-consumption-info {
  font-size: 13px;
  font-weight: 600;
  color: #585858;
  margin-bottom: 0px;
}

.table-opening-table-date {
  font-size: 11px;
  font-weight: 600;
  color: #585858;
  margin-bottom: 4px;
}

#upper-bar {
  position: absolute;
  top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;

  padding-right: 1%;
}

#profile-and-cart {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
}

#language-select {
  position: absolute;
  right: 200px;
  top: 8px;
  cursor: pointer;
}

.language-position-in-login {
  right: 159px !important;
  z-index: 202;
}

#enter-prompt {
  position: absolute;
  top: 8px;
  right: 88px !important;
  z-index: 201;
}

#profile-dropdown {
  position: absolute;
  top: 0px;
  right: 88px !important;
  z-index: 201;
}

#back-to-services {
  position: fixed;
  left: 80px;
  box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.32), 3px 4px 8px rgba(0, 0, 0, 0.46);
}

#logo-container {
  background: white !important;
  /* height: 45px; */
  margin-left: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  padding: 0px 16px 0px 12px;
  border-radius: 12px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24), 2px 2px 4px rgba(0, 0, 0, 0.36);
}

#logo {
  cursor: pointer;
  height: 40px;
  width: auto;
}

#link-to-landing {
  text-decoration: none;
}

.just-closed-table {
  background-color: #f9d876;
}

.open-table {
  background-color: #afffa9;
}

.blue-table {
  background-color: #66d9f6;
}

.red-table {
  background-color: #ffafaf;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 204;
  opacity: 1;
  transition: 0.67s;
}

.hide {
  visibility: hidden;
  display: none;
}

#loading-mask {
  position: fixed;
  top: 0;
}

@media screen and (max-width: 1018px) {
  #language-select {
    left: unset;
    top: 5px !important;
    right: 20px;
    cursor: pointer;
  }

  .language-position-in-login {
    right: 20px !important;
    z-index: 202;
  }

  .no-bottom-margin {
    margin-bottom: 0px !important;
  }

  #profile-dropdown {
    right: 20px !important;
  }

  .profile-dropdown-with-lang-select {
    top: 58px !important;
  }

  .profile-dropdown-without-lang-select {
    top: 2px !important;
  }

  #enter-prompt {
    right: 20px !important;
    margin: 0;
  }

  .enter-prompt-with-lang-select {
    top: 56px !important;
  }

  .enter-prompt-without-lang-select {
    top: 5px !important;
  }

  #back-to-services {
    left: 20px;
  }

  #logo-container {
    min-width: 95px !important;
    justify-content: flex-start;
    margin-left: 20px;
  }

  #logo {
    height: 33px;
  }

  #banner {
    height: 40vh;
  }

  #store-info {
    top: 165px;
    width: 90%;
    left: 5%;
    min-width: 200px;
    max-height: 112px;
  }

  #table-items {
    width: 101vw;
    margin-bottom: 9vh;
  }

  #upper-bar {
    top: 15px;
    height: unset;
  }
}

@media screen and (max-width: 350px) {
  #store-info {
    top: 140px;
  }
}

@media screen and (max-width: 370px) {
  .open-tables-details-title {
    font-size: 13px;
  }
}

@media screen and (max-width: 1018px) {
  #banner {
    height: 290px !important;
  }
}

@media screen and (max-width: 530px) {
  #banner {
    height: 280px !important;
  }
}

@media screen and (max-width: 350px) {
  #banner {
    height: 250px !important;
  }
}

@media screen and (max-width: 330px) {
  #banner {
    height: 235px !important;
  }
}
</style>
